/* @ngInject */
const local = (
  valueHandler,
  storageHandler
) => {
  const self = {}

  self.saveCurrentId = (_id) => {
    if (valueHandler.isId(_id)) {
      storageHandler.save('currentAreaId', _id)
    } else if (valueHandler.isId(_id.id)) {
      storageHandler.save('currentAreaId', _id.id)
    }
  }

  self.getCurrentId = () => {
    return storageHandler.get('currentAreaId')
  }

  return self
}

export default local



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/services/local.service.js